var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrairieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.843,
    height: 49.721,
    fill: "#e9f2f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1007 -5306)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(1007 5306)",
    fill: "#963839"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1037.578 5374.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.334,19.5,93.171.054A.714.714,0,0,0,92.9,0H65.062A.71.71,0,0,0,64.8.049L43.933,8.277,38.554,4.724a.716.716,0,0,0-.655-.068L.449,19.521a.712.712,0,0,0,.262,1.373H4.254V44.527H2.465a.712.712,0,0,0-.712.711V49.01a.712.712,0,0,0,.712.711H138.377a.712.712,0,0,0,.711-.711V45.239a.712.712,0,0,0-.711-.711h-2.113V20.894h3.867a.712.712,0,0,0,.2-1.394m-8.223,25.027H110.089V20.894h22.022ZM108.667,20.894V44.527h-1.308V20.894h1.308Zm-35.783,0h1.307V44.527H72.883Zm2.731,0H92.188V44.527H75.614Zm30.321,3.6H96.342v-3.6h9.594Zm-11.017.711v19.32H93.611V20.894h1.308Zm1.423.712h9.594V44.527H96.341Zm-.711-6.448h-20.8L90.3,10.536l15.476,8.935ZM71.46,44.527H58.446V20.894H71.46Zm-17.168,0H8.407V20.894H54.292Zm2.731,0H55.715V20.894h1.307ZM38.079,6.116l5.375,3.55,0,0,14.84,9.8H4.433ZM5.676,20.894H6.984V44.527H5.676ZM137.665,48.3H3.176V45.95H137.665Zm-2.824-3.771h-1.308V20.894h1.308Zm.711-25.056H108.626L90.66,9.1a.711.711,0,0,0-.711,0L71.981,19.471h-11.1L54.117,15,45.383,9.235,65.2,1.423H92.758L136.53,19.471Z",
    transform: "translate(0 0)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.015,62.047h-10.05a.712.712,0,0,0-.711.711V73.827a.712.712,0,0,0,.711.712h10.05a.712.712,0,0,0,.711-.712V62.758a.712.712,0,0,0-.711-.711M193.3,63.47v5.017h-8.627V63.47Zm-8.627,9.646v-3.2H193.3v3.205Z",
    transform: "translate(-105.09 -35.582)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4,74.539h10.05a.712.712,0,0,0,.711-.712V62.758a.712.712,0,0,0-.711-.711H86.4a.712.712,0,0,0-.711.711V73.827a.712.712,0,0,0,.711.712m.711-1.423v-3.2H95.74v3.2ZM95.74,63.47v5.018H87.113V63.47Z",
    transform: "translate(-49.14 -35.582)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.12,74.539H45.17a.712.712,0,0,0,.711-.712V62.758a.712.712,0,0,0-.711-.711H35.12a.712.712,0,0,0-.711.711V73.827a.712.712,0,0,0,.711.712m.711-1.423v-3.2h8.627v3.2Zm8.627-9.646v5.018H35.832V63.47Z",
    transform: "translate(-19.732 -35.582)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.98,74.539H150.1a.712.712,0,0,0,.711-.712V62.758a.712.712,0,0,0-.711-.711H142.98a.712.712,0,0,0-.712.711V73.827a.712.712,0,0,0,.712.712m.711-7.861h5.7v6.438h-5.7Zm5.695-1.423h-5.7V63.469h5.7Z",
    transform: "translate(-81.586 -35.582)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.18,74.539h10.05a.712.712,0,0,0,.711-.712V62.758a.712.712,0,0,0-.711-.711H271.18a.711.711,0,0,0-.711.711V73.827a.712.712,0,0,0,.711.712m.711-1.423v-3.2h8.628v3.2Zm8.628-9.646v5.018h-8.628V63.47Z",
    transform: "translate(-155.105 -35.582)",
    fill: "#e9f2f0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrairieIcon);
export default __webpack_public_path__ + "static/media/PrairieIcon.fc0dccc60f8706955261ff828135afb3.svg";
export { ForwardRef as ReactComponent };